import React from 'react'

export const ArrowIcon = () => (
    <svg height="10" width="15" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11 1 15 5M15 5 11 9M15 5H1"
            stroke="#ffffff"
            strokeLinecap="round"
        />
    </svg>
)
